/* global Resources, Services, Sys, Core, Game */

/**
 * Applies middleware by its configured parameters. Should be called after services initialization.
 *
 * @param {Object} middleware Middleware object.
 * @returns {void}
 */
Services.applyMiddleware = function(middleware) {
    Object.keys(middleware.rules).forEach(function(service) {
        Object.keys(middleware.rules[service]).forEach(function(event) {
            if (service in window.Services) {
                window.Services[service].use(
                    event,
                    middleware.rules[service][event]
                );
            }
            else {
                throw new Error("Attempt to apply " + middleware.name + ", but service " + service + " does not exists!");
            }
        });
    });
};

/**
 * Applies multiple middleware by its configured parameters. Should be called after services initialization.
 *
 * @param {Array} middlewareArray Middleware set to apply in certain order.
 * @returns {void}
 */
Services.applyMultipleMiddleware = function(middlewareArray) {
    middlewareArray.forEach(Services.applyMiddleware);
};

Services.initServices = function(defaultBettingModes, gameReadyBlocker) {
    var initResponse = Resources.readData("gameServerInitResponse"),
        parsedResponse = Resources.readData("gameServerInitResponseObject"),
        currencyFormat = Services.moneyManager.getCurrencyFormat(),
        currencyCode = currencyFormat.currencyChar || currencyFormat.iso,
        currencyLabel = currencyFormat.showCurrencyChar ? currencyCode : "",
        hasGameReadyBlocker = gameReadyBlocker === true,
        observable;

    window.Services = Sys.apply(window.Services, {
        activity: new Services.Activity(),
        autoplay: new Services.Autoplay({ initResponse: initResponse, currencyLabel: currencyLabel }),
        bet: new Services.Bet({ initResponse: initResponse }),
        clock: new Services.Clock({ parsedResponse: parsedResponse }),
        customMessage: new Services.CustomMessage(),
        dialog: new Services.Dialog(),
        error: new Services.Error(),
        freeRounds: new Services.FreeRounds({ initResponse: initResponse }),
        freeSpins: new Services.FreeSpins(),
        game: new Services.Game({ initResponse: initResponse, parsedResponse: parsedResponse, hasGameReadyBlocker: hasGameReadyBlocker }),
        gameInformation: new Services.GameInformation(),
        gameRound: new Services.GameRound({ initResponse: initResponse }),
        gameRules: new Services.GameRules(),
        gameSettings: new Services.GameSettings({ parsedResponse: parsedResponse }),
        money: new Services.Money({ defaultBettingModes: defaultBettingModes }),
        paytable: new Services.Paytable(),
        pluginMenu: new Services.PluginMenu(),
        ticker: new Services.Ticker(),
        win: new Services.Win({ initResponse: initResponse }),
        response: new Services.Response({ initResponse: parsedResponse }),
        spin: new Services.Spin({ parsedResponse: parsedResponse })
    });

    /* INITIATE OSS INTEGRATION */
    if (Resources.readData("isOSSIntegration")) {
        Core.gameAdapterApi.init(Game.messageApi, window.Services);
    }

    observable = new window.Sys.Observable();

    observable.fireEvent("notify:services.init");

    window.Services.game.on(
        "ready",
        function() {
            /**
             * Handles entering game for environments that not use netent loader screen. Originated from GFW-4093.
             * */
            if (Sys.isGcmEnabled) {
                observable.fireEvent("notify:loader.closed");
            }
        }
    );
};
